(function () {
  function init() {
    const productJsonEl = document.getElementById('ProductJson');
    if (!productJsonEl) return;

    let product;
    try { product = JSON.parse(productJsonEl.textContent); }
    catch (e) { return; }

    const allMedia = product.media || [];
    if (allMedia.length === 0) return;

    // Farb-Reihenfolge basierend auf featured_media Position
    const colorFeaturedMediaIds = {};
    product.variants.forEach(v => {
      if (!colorFeaturedMediaIds[v.option1] && v.featured_media) {
        colorFeaturedMediaIds[v.option1] = v.featured_media.id;
      }
    });

    const colorOrder = Object.entries(colorFeaturedMediaIds)
      .map(([color, mediaId]) => ({
        color, mediaId,
        position: allMedia.findIndex(m => m.id === mediaId)
      }))
      .filter(c => c.position >= 0)
      .sort((a, b) => a.position - b.position);

    const mediaColorMap = {};
    allMedia.forEach((m, index) => {
      let assigned = colorOrder.length > 0 ? colorOrder[0].color : null;
      colorOrder.forEach(c => { if (index >= c.position) assigned = c.color; });
      mediaColorMap[m.id] = assigned;
    });

    function getImagesForColor(color) {
      return allMedia.filter(m => mediaColorMap[m.id] === color);
    }

    let currentColor = null;

    function filterGallery(color, force = false) {
      if (!color || (color === currentColor && !force)) return;
      currentColor = color;

      const images = getImagesForColor(color);
      const mediaIds = new Set(images.map(m => String(m.id)));

      // Thumbnails filtern
       // Thumbnails filtern
      document.querySelectorAll('.strong-thumbs-slide').forEach(el => {
        const mediaId = (el.getAttribute('data-id') || '').split('-').pop();
        if (mediaIds.has(mediaId)) {
          el.classList.remove('hidden-slide');
        } else {
          el.classList.add('hidden-slide');
        }
        el.classList.remove('active-thumb');
      });


      // Hauptbilder filtern
      document.querySelectorAll('.main-item').forEach(el => {
        const mediaId = (el.getAttribute('data-id') || '').split('-').pop();
        el.style.display = mediaIds.has(mediaId) ? '' : 'none';
      });

      // Erstes Thumbnail aktiv setzen
      const firstThumb = document.querySelector('.strong-thumbs-slide:not([style*="none"])');
      if (firstThumb) firstThumb.classList.add('active-thumb');
    }
        // Hover auf Thumbnails → Hauptbild-src tauschen
    document.addEventListener('mouseover', function(e) {
      const thumb = e.target.closest('.strong-thumbs-slide');
      if (!thumb || thumb.classList.contains('hidden-slide')) return;

      const thumbImg = thumb.querySelector('img');
      if (!thumbImg) return;

      const dataId = thumb.getAttribute('data-id');
      const mediaId = dataId ? dataId.split('-').pop() : null;
      const mediaObj = mediaId ? allMedia.find(m => String(m.id) === mediaId) : null;

      // width=200 → width=1200 für scharfe Qualität
      let newSrc;
      if (mediaObj && mediaObj.src) {
        const base = 'https:' + mediaObj.src.split('?')[0];
        const version = (mediaObj.src.match(/v=(\d+)/) || [])[1] || '';
        newSrc = base + '?v=' + version + '&width=1200';
      } else {
        newSrc = thumbImg.src.replace(/width=\d+/, 'width=1200');
      }

      const mainItem = document.querySelector('.main-item:not([style*="display: none"]):not([style*="display:none"])');
      if (mainItem) {
        const mainImg = mainItem.querySelector('img');
        if (mainImg) {
          const w = mainImg.offsetWidth;
          const h = mainImg.offsetHeight;
          mainImg.style.width = w + 'px';
          mainImg.style.height = h + 'px';
          mainImg.style.objectFit = 'contain';
          mainImg.src = newSrc;
          mainImg.srcset = '';
        }
      }

      document.querySelectorAll('.strong-thumbs-slide').forEach(t => t.classList.remove('active-thumb'));
      thumb.classList.add('active-thumb');
    });

    // Varianten-Selektoren überwachen
    function getCurrentColor() {
      const checkedRadio = document.querySelector('.variant-field input[type="radio"]:checked, .product-variants input[type="radio"]:checked');
      if (checkedRadio) return checkedRadio.value;

      const selects = document.querySelectorAll('.product-variants select, .variant-field select');
      if (selects.length > 0) return selects[0].value;

      const activeBtn = document.querySelector('.swatch-item.active, .variant-button.active, [data-value].active');
      if (activeBtn) return activeBtn.getAttribute('data-value') || activeBtn.textContent.trim();

      return null;
    }

    document.addEventListener('click', function(e) {
      const variantEl = e.target.closest('.product-variants, .variant-field, .swatch-item, [data-option]');
      if (!variantEl) return;
      setTimeout(() => {
        const color = getCurrentColor();
        if (color) filterGallery(color);
      }, 50);
    });

    document.addEventListener('change', function(e) {
      if (e.target.closest('.product-variants, .variant-field, form[action*="/cart/add"]')) {
        setTimeout(() => {
          const color = getCurrentColor();
          if (color) filterGallery(color);
        }, 50);
      }
    });

    // hidden input überwachen
    const hiddenInput = document.querySelector('input[name="id"]');
    if (hiddenInput) {
      const origSet = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
      Object.defineProperty(hiddenInput, 'value', {
        set(val) {
          origSet.call(this, val);
          const variant = product.variants.find(v => String(v.id) === String(val));
          if (variant) filterGallery(variant.option1);
        },
        get() {
          return Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').get.call(this);
        }
      });
    }

    // Initial mit force=true laden
    const initVariantId = hiddenInput?.value || product.variants[0]?.id;
    const initVariant = product.variants.find(v => String(v.id) === String(initVariantId));
    if (initVariant) filterGallery(initVariant.option1, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

    // Loop: Pfeil-Buttons am Ende/Anfang wieder zum ersten/letzten Bild
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.strong-slide-next, .strong-slide-prev, [class*="next"], [class*="prev"], [class*="arrow"]');
      if (!btn) return;

      const visibleSlides = Array.from(document.querySelectorAll('.main-item')).filter(el => !el.classList.contains('hidden-slide') && el.style.display !== 'none');
      if (visibleSlides.length === 0) return;

      // Aktiven Slide finden
      const activeSlide = document.querySelector('.main-item.active, .main-item.is-selected, .main-item[aria-hidden="false"]') || visibleSlides[0];
      const currentIndex = visibleSlides.indexOf(activeSlide);

      const isNext = btn.closest('.strong-slide-next, [class*="next"], [class*="right-arrow"]');
      const isPrev = btn.closest('.strong-slide-prev, [class*="prev"], [class*="left-arrow"]');

      setTimeout(() => {
        // Prüfen ob Slider am Ende/Anfang steckt
        const newActive = document.querySelector('.main-item.active, .main-item.is-selected, .main-item[aria-hidden="false"]');
        const newIndex = visibleSlides.indexOf(newActive);

        if (isNext && newIndex === currentIndex) {
          // Am Ende → zum ersten springen
          visibleSlides[0]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          visibleSlides[0]?.click();
        } else if (isPrev && newIndex === currentIndex) {
          // Am Anfang → zum letzten springen
          visibleSlides[visibleSlides.length - 1]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          visibleSlides[visibleSlides.length - 1]?.click();
        }
      }, 100);
    });


